import { For } from "solid-js";
import "./school.css";
import type { DashboardEntry } from "./team";

const STEPS: Record<"welcome-principal" | "welcome-teacher", { title: string; lead: string; steps: string[] }> = {
  "welcome-principal": {
    title: "Ihr Test läuft",
    lead: "Schön, dass Sie dabei sind. So geht es weiter:",
    steps: [
      "Laden Sie Ihre Lehrkräfte ein. Im Menü finden Sie dafür den Punkt „Schule“.",
      "Die Lehrkräfte legen ihre Klassen an, im Test bis zu 3 Klassen für die ganze Schule.",
      "Die Schüler melden sich mit dem Klassen-Code an."
    ]
  },
  "welcome-teacher": {
    title: "Schön, dass Sie da sind",
    lead: "Ihr Konto gehört jetzt zu Ihrer Schule. Als Nächstes:",
    steps: [
      "Legen Sie Ihre erste Klasse an (Plus-Knopf neben der Klassenauswahl). Im Test sind 3 Klassen für die ganze Schule möglich.",
      "Fügen Sie Ihre Schüler hinzu.",
      "Geben Sie den Klassen-Code an die Schüler weiter."
    ]
  }
};

export function WelcomeCard(props: { entry: Exclude<DashboardEntry, "principal">; onClose: () => void }) {
  const content = () => STEPS[props.entry as "welcome-principal" | "welcome-teacher"];
  return (
    <section class="card so-welcome" aria-labelledby="so-welcome-title">
      <h2 class="sr-title" id="so-welcome-title">{content().title}</h2>
      <p class="sr-sub">{content().lead}</p>
      <ol class="so-steps"><For each={content().steps}>{(step) => <li>{step}</li>}</For></ol>
      <button class="btn btn-full" type="button" onClick={props.onClose}>Verstanden</button>
      <p class="sr-hint" style={{ "text-align": "center" }}>Beim nächsten Mal melden Sie sich über die Login-Seite an.</p>
    </section>
  );
}
